import moment from 'moment';

// SQL Server datetime constraint: 1/1/1753 12:00:00 AM to 12/31/9999 11:59:59 PM
// Exported as factory functions to ensure each caller gets a fresh moment object
// and prevents mutation of shared singletons
export const getSqlMinDate = () => moment('1753-01-01', 'YYYY-MM-DD').startOf('day');
export const getSqlMaxDate = () => moment('9999-12-31', 'YYYY-MM-DD').endOf('day');
